import { Flex as ChakraFlex } from '@chakra-ui/react';

export const Flex = ChakraFlex;
